import React from 'react';
import { henleyFlagLink } from '../../../hooks/utils';
import  styles from  './country-flag-openness.module.scss'; // import CSS file with animation styles

const  CountryFlag= ({iso, country, region}) => {

    return (
      <span className={styles.countryFlag}>
          <img src={henleyFlagLink(iso)} alt={country} />
          <div className={styles.name}>
              <span className={styles.countryName}>{country}</span>
              {region && <span className={`${styles.regionName} ${styles.cellHideDesktop}` }>{region}</span>}
          </div>
      </span>
    )

}

export default CountryFlag;
